import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconPrinterProps extends SVGProps<any> {}
export class SVGIconPrinter extends Component<SVGIconPrinterProps> {
  render() {
    const { width = 25, height = 25, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-back"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 33 33`}
        {...rest}
      >
        <g filter="url(#filter0_d_3193_97)">
          <path
            d="M23.7917 6.25V4.16667C23.7917 3.0616 23.3527 2.00179 22.5713 1.22039C21.7899 0.438987 20.7301 0 19.625 0L13.375 0C12.2699 0 11.2101 0.438987 10.4287 1.22039C9.64732 2.00179 9.20833 3.0616 9.20833 4.16667V6.25C7.82751 6.25165 6.50371 6.80092 5.52731 7.77731C4.55092 8.75371 4.00165 10.0775 4 11.4583L4 16.6667C4.00165 18.0475 4.55092 19.3713 5.52731 20.3477C6.50371 21.3241 7.82751 21.8733 9.20833 21.875C9.20833 22.7038 9.53757 23.4987 10.1236 24.0847C10.7097 24.6708 11.5045 25 12.3333 25H20.6667C21.4955 25 22.2903 24.6708 22.8764 24.0847C23.4624 23.4987 23.7917 22.7038 23.7917 21.875C25.1725 21.8733 26.4963 21.3241 27.4727 20.3477C28.4491 19.3713 28.9983 18.0475 29 16.6667V11.4583C28.9983 10.0775 28.4491 8.75371 27.4727 7.77731C26.4963 6.80092 25.1725 6.25165 23.7917 6.25ZM11.2917 4.16667C11.2917 3.61413 11.5112 3.08423 11.9019 2.69353C12.2926 2.30283 12.8225 2.08333 13.375 2.08333H19.625C20.1775 2.08333 20.7074 2.30283 21.0981 2.69353C21.4888 3.08423 21.7083 3.61413 21.7083 4.16667V6.25H11.2917V4.16667ZM21.7083 21.875C21.7083 22.1513 21.5986 22.4162 21.4032 22.6116C21.2079 22.8069 20.9429 22.9167 20.6667 22.9167H12.3333C12.0571 22.9167 11.7921 22.8069 11.5968 22.6116C11.4014 22.4162 11.2917 22.1513 11.2917 21.875V17.7083C11.2917 17.4321 11.4014 17.1671 11.5968 16.9718C11.7921 16.7764 12.0571 16.6667 12.3333 16.6667H20.6667C20.9429 16.6667 21.2079 16.7764 21.4032 16.9718C21.5986 17.1671 21.7083 17.4321 21.7083 17.7083V21.875ZM26.9167 16.6667C26.9167 17.4955 26.5874 18.2903 26.0014 18.8764C25.4153 19.4624 24.6205 19.7917 23.7917 19.7917V17.7083C23.7917 16.8795 23.4624 16.0847 22.8764 15.4986C22.2903 14.9126 21.4955 14.5833 20.6667 14.5833H12.3333C11.5045 14.5833 10.7097 14.9126 10.1236 15.4986C9.53757 16.0847 9.20833 16.8795 9.20833 17.7083V19.7917C8.37953 19.7917 7.58468 19.4624 6.99862 18.8764C6.41257 18.2903 6.08333 17.4955 6.08333 16.6667V11.4583C6.08333 10.6295 6.41257 9.83467 6.99862 9.24862C7.58468 8.66257 8.37953 8.33333 9.20833 8.33333H23.7917C24.6205 8.33333 25.4153 8.66257 26.0014 9.24862C26.5874 9.83467 26.9167 10.6295 26.9167 11.4583V16.6667Z"
            fill="#364856"
          />
        </g>
        <g filter="url(#filter1_d_3193_97)">
          <path
            d="M22.75 10.4165H20.6667C20.3904 10.4165 20.1254 10.5263 19.9301 10.7216C19.7347 10.917 19.625 11.1819 19.625 11.4582C19.625 11.7344 19.7347 11.9994 19.9301 12.1947C20.1254 12.3901 20.3904 12.4998 20.6667 12.4998H22.75C23.0263 12.4998 23.2912 12.3901 23.4866 12.1947C23.6819 11.9994 23.7917 11.7344 23.7917 11.4582C23.7917 11.1819 23.6819 10.917 23.4866 10.7216C23.2912 10.5263 23.0263 10.4165 22.75 10.4165Z"
            fill="#364856"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3193_97"
            x="0"
            y="0"
            width="33"
            height="33"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3193_97"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3193_97"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_3193_97"
            x="15.625"
            y="10.4165"
            width="12.1667"
            height="10.0835"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3193_97"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3193_97"
              result="shape"
            />
          </filter>
        </defs>
      </SVG>
    );
  }
}
